export default "__VITE_ASSET__CX7rW1nO__"